import { render, staticRenderFns } from "./ClientViewClientInfoCard.vue?vue&type=template&id=d88ae418&"
import script from "./ClientViewClientInfoCard.vue?vue&type=script&lang=js&"
export * from "./ClientViewClientInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports